// See https://www.npmjs.com/package/mirror-creator
// Allows us to set up constants in a slightly more concise syntax. See:
// client/app/bundles/HelloWorld/actions/helloWorldActionCreators.jsx

const types = {
  NEXT_PAGE: "NEXT_PAGE",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  TOGGLE_MODAL: "TOGGLE_MODAL",
  PREVIOUS_PAGE: "PREVIOUS_PAGE",
};

export default types;
